import { ReactNode } from 'react';
import { Footer } from '@/components/common';
import { useCommonParams, useFirstIncome, useOrganicUser } from '@/hooks';
import WebViewHeader from '@/components/common/layout/WebViewHeader';
import styled from 'styled-components';
import { rem } from '@/styles/theme';

interface IProps {
  children: ReactNode;
}

interface IStyledProps {
  firstIncome: boolean;
  isOrganicUser: boolean;
  isNotLGU: boolean;
}

const Container = styled.div<IStyledProps>`
  background: #ffffff;
  max-width: ${rem(414)};
  margin: 0 auto;
  padding-top: ${rem(52)};
  ${({ firstIncome, isOrganicUser, isNotLGU }) =>
    isOrganicUser && firstIncome && isNotLGU
      ? `
  padding-top: ${rem(80)} 
  `
      : `
  padding-top: ${rem(52)};
`}
`;

const CollectionLayout = (props: IProps) => {
  const { children } = props;
  const [firstIncome] = useFirstIncome();
  const [isOrganicUser] = useOrganicUser();
  const { media } = useCommonParams();
  const isNotLGU = media !== 'lgu';

  return (
    <Container firstIncome={firstIncome} isOrganicUser={isOrganicUser} isNotLGU={isNotLGU}>
      <WebViewHeader />
      <main style={{ paddingBottom: rem(32) }}>{children}</main>
      <Footer />
    </Container>
  );
};

export default CollectionLayout;
